import * as React from 'react'

import { Box, Grid } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import Complaint from 'modules/complaints/components/Complaints/Complaint'
import { ComplaintProvider } from 'modules/complaints/components/Complaints/Complaint/complaintContext'
import Table from 'modules/complaints/components/Complaints/Table'
import complaints from 'modules/complaints/store/collections/complaints'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

interface Props {
  paramsId?: number
}

function ComplaintsPage({ paramsId }: Props) {
  const [selectedComplaintId, setSelectedComplaintId] = React.useState<number | null>(
    paramsId || null
  )

  const { loading } = useAsyncData(() => complaints.fetch(), [])

  const onDeleteComplaint = () => {
    setSelectedComplaintId(null)
  }

  return (
    <ResponsivePage.Body loading={loading} error={null}>
      <Grid variant="fixed">
        <Box gridColSpan={{ xs: 4, s: 4 }} gap="s8">
          <Table
            onComplaintSelect={setSelectedComplaintId}
            selectedComplaint={selectedComplaintId}
          />
        </Box>
        <Box gridColSpan={{ s: 7 }}>
          <ComplaintProvider complaintId={selectedComplaintId}>
            <Complaint onDeleteComplaint={onDeleteComplaint} />
          </ComplaintProvider>
        </Box>
      </Grid>
    </ResponsivePage.Body>
  )
}

export default observer(ComplaintsPage)
